import axios from 'axios';
import store from '@/store';
import _ from 'lodash';

const apiPath = `${store.state.apiPathWithVersion}/product`;

export default {
  async list(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`, {
        params: params,
      });
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },

  async gateways(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/gateway`, {
        params: params,
      });
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },

  async buy(method, params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.callbackUrl = window.location.origin;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/${method}?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },

  async buyAddonPayments(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    params.callbackUrl = window.location.toString();
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/addonPayments?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },

  canBuyPack() {
    if (typeof store.state.user === 'undefined') {
      return false;
    }
    let exists = _.find(
      store.state.user.roles,
      (it) => it.authority === 'ROLE_BUY_BALANCE'
    );
    return typeof exists !== 'undefined';
  },

  async useFreeProductCoupon(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/useFreeProductCoupon?lang=${params.lang}`,
        params
      );
      return {
        data: resp.data,
        error: false,
      };
    } catch (error) {
      return {
        data: error.data,
        error: true,
      };
    }
  },
};
